import React from 'react';
import { useParams } from 'react-router-dom';

import { OfferConfigurePageContainer } from '@occc-app/offerHelpers/components/OfferConfigurePageContainer';
import { OfferType } from '@occc-app/offerValidationService/types';
import { getCreatePageLinks } from '@occc-app/routes/ProgramManagement/utils';

import { messages } from '../messages';
import { LoyaltyEventConfigureFormContainer } from '../components/LoyaltyEventConfigureForm/LoyaltyEventConfigureFormContainer';

export const LoyaltyEventConfigurePageContainer: React.FC = () => {
  const { offerId = '' } = useParams<{ offerId: string }>();

  return (
    <OfferConfigurePageContainer
      offerId={offerId}
      getBreadcrumbLinks={() =>
        getCreatePageLinks(messages.configurePageTitle, OfferType.LoyaltyEvent)
      }
      pageTitle={messages.configurePageTitle}
      subtitle={messages.subtitle}
      offerType={OfferType.LoyaltyEvent}
      ConfigureFormContainer={LoyaltyEventConfigureFormContainer}
      showSurgeonGeneralsWarning={false}
    />
  );
};
